import { z } from 'zod';
import { LocationMappedCEFieldSchema } from '../inputTypeSchemas/LocationMappedCEFieldSchema'

/////////////////////////////////////////
// CODE ENFORCEMENT LOCATION FIELD MAPPING SCHEMA
/////////////////////////////////////////

export const CodeEnforcementLocationFieldMappingSchema = z.object({
  targetedCEField: LocationMappedCEFieldSchema.nullable(),
  id: z.number().int(),
  cityId: z.number().int(),
  locationCustomFieldId: z.number().int(),
  ceCaseExtensionDefId: z.number().int().nullable(),
})

export type CodeEnforcementLocationFieldMapping = z.infer<typeof CodeEnforcementLocationFieldMappingSchema>

export default CodeEnforcementLocationFieldMappingSchema;
